<template>
  <div>
    <scout-members
      :member-objects="memberObjects"
      :contract-id="Number($route.params.contractId)"
      :job-id="Number($route.params.jobId)"
      display-key="candidate"
      data-test="scout-members"
      :count="count"
      :count-limit="countLimit"
      @fetch="fetch"
    />
  </div>
</template>

<script>
import ScoutMembers from '@/components/organisms/ScoutMembers.vue'
import Indicator from '@/lib/indicator'
import _ from 'lodash'

export default {
  components: {
    ScoutMembers
  },
  data () {
    return {
      members: [],
      countLimit: 5000,
      count: 0
    }
  },
  computed: {
    memberObjects () {
      return this.members.map((member) => {
        return {
          id: member.id,
          member: member
        }
      })
    }
  },
  watch: {
    $route: {
      handler () {
        this.fetch()
      }
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch (page = 1) {
      Indicator.emitShow()
      this.fetchCandidateCount().then(response => {
        this.$set(this, 'count', response.data)
        this.fetchCandidates(page)
      }).catch(() => {
        Indicator.emitHide()
      })
    },
    fetchCandidates (page) {
      this.$http.secured.get(`/scout/view/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/candidates/pages/${page}`)
        .then(response => {
          this.setProperty(response.data)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    setProperty (candidates) {
      this.$set(this, 'members', candidates.map(candidate => _.set(candidate, 'isScoutExcluded', false)))
    },
    fetchCandidateCount () {
      return this.$http.secured.get(`/scout/view/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/candidates/_count`)
    }
  }
}
</script>
